import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { WizardTemplate } from "@radarly/models/insight-pages/wizard/model";
import { WizardConfiguration } from "@radarly/models/insight-pages/wizard/model/configuration";
import { IRouterService } from "@radarly/shared/router";
import { useWizardEditorIO } from "./useWizardEditorIO";
import { useWizardInsightPageGenerator } from "./useWizardInsightPageGenerator";
import { useWizardPreviewValidity } from "./useWizardPreviewValidity";

export function useWizardSubheader({
  template,
  configuration,
  router,
}: {
  template: WizardTemplate;
  configuration: WizardConfiguration;
  router: IRouterService;
}) {
  const locale = useCurrentUserLocale();
  const { goToInsightPageList, goToInsightPage } = useWizardEditorIO(router);
  const { generateInsightPage } = useWizardInsightPageGenerator(template);
  const { isValid } = useWizardPreviewValidity(template, configuration);
  const onGenerate = async () => {
    const savedPage = await generateInsightPage(configuration);
    goToInsightPage(savedPage);
  };
  return {
    color: configuration.color,
    title: configuration.title,
    picture: null,
    timezone: tr(locale, "CUSTOM_PAGE_TIMEZONE", {
      timezone: configuration.timezone,
    }),
    buttons: {
      submit: {
        label: tr(locale, "INSIGHT_PAGE_WIZARD::GENERATE"),
        isDisabled: !isValid,
        onClick: onGenerate,
        variant: "primary" as const,
        size: "m" as const,
      },
      cancel: {
        label: tr(locale, "INSIGHT_PAGE_WIZARD::CANCEL"),
        onClick: goToInsightPageList,
        variant: "tertiary" as const,
        size: "m" as const,
      },
    },
  };
}
